<app-search-tabs
  (selectTab)="tabSelectedByUser($event)"
  [currentTab]="selectedTab()"
></app-search-tabs>

@if (selectedTab() <= 4) {
  <div class="search__container py-3 px-4 px-lg-0">
    <div class="search__container__metasearch__form container rounded-4">
      @if (selectedTab() === HomeTab.FLIGHTS) {
        <app-flight-search></app-flight-search>
      } @else if (selectedTab() === HomeTab.PACKAGES) {
        <app-tab-vuelo-hotel></app-tab-vuelo-hotel>
      } @else if (selectedTab() === HomeTab.HOTELS) {
        <app-tab-hotel></app-tab-hotel>
      }
    </div>
  </div>
}

<router-outlet></router-outlet>
